import { SidebarProvider } from '@/components/ui/sidebar';

interface AppShellProps {
    children: React.ReactNode;
    variant?: 'header' | 'sidebar';
    sidebarDefaultOpen?: boolean;
    sidebarHoverToExpand?: boolean;
}

export function AppShell({
    children,
    variant = 'header',
    sidebarDefaultOpen = true,
    sidebarHoverToExpand = false,
}: AppShellProps) {
    if (variant === 'header') {
        return (
            <div className="flex min-h-screen w-full flex-col">{children}</div>
        );
    }

    return (
        <SidebarProvider
            defaultOpen={sidebarDefaultOpen}
            hoverToExpand={sidebarHoverToExpand}
            className="bg-cover bg-center bg-no-repeat bg-fixed"
            style={{ backgroundImage: "url('/ocean_bg_web.jpg')" }}
        >
            {children}
        </SidebarProvider>
    );
}

export default AppShell;
